import { AccountsEntity } from '@/domain/entities/account';
import { ChangePasswordPayload } from '@/domain/ports/account/payloads';
import { AccountsRepository } from '@/domain/ports/account/repositories';

export class ChangePasswordUseCase {
  constructor(private readonly repository: AccountsRepository) {}

  async run(payload: ChangePasswordPayload): Promise<AccountsEntity> {
    const account = await this.repository.changePassword(payload);
    return account;
  }
}
